import { StyleSheet } from 'aphrodite';
import { aceGray, brandPrimary, charmGray, titles, white } from '../../../styles/colors';
import { shadowSm } from '../../../styles/shadows';

export const s = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: 12,
		width: '100%',
		boxSizing: 'border-box',
	},
	imageManagerContainer: {
		paddingBottom: 12,
		borderBottom: `1px solid ${aceGray}`,
	},
	inputWrapper: {
		boxSizing: 'border-box',
		border: `1px solid ${aceGray}`,
		display: 'flex',
		alignItems: 'flex-start',
		gap: 8,
		width: '100%',
		minWidth: 0,
		borderRadius: 8,
		background: white,
		padding: '8px 12px',
		boxShadow: shadowSm,
		transition: 'color, box-shadow',
		outline: 'none',
		':has([data-slot="input"]:focus)': {
			borderColor: brandPrimary,
		},
		':has(*) svg': {
			color: `${titles}96`,
			flexShrink: 0,
		},
		':has([data-slot="input"]:focus) button svg': {
			color: brandPrimary,
		},
	},
	addImageButton: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: 24,
		height: 24,
		borderRadius: 12,
		border: `1.5px solid ${aceGray}`,
		flexShrink: 0,
		backgroundColor: white,
		cursor: 'pointer',
		padding: 0,
		marginTop: 2,
		transition: 'background-color 0.2s, border-color 0.2s',
		':hover:not(:disabled)': {
			backgroundColor: '#f0f9ff',
		},
		':disabled': {
			opacity: 0.5,
			cursor: 'not-allowed',
		},
	},
	addImageIcon: {
		// width: 18,
		// height: 18,
	},
	promptInput: {
		display: 'block',
		width: '100%',
		boxSizing: 'border-box',
		backgroundColor: 'transparent',
		border: 'none',
		resize: 'none',
		fieldSizing: 'content',
		maxHeight: 96,
		outline: 'none',
		padding: 0,
		minHeight: 24,
		fontFamily: 'inherit',
		fontSize: 14,
		lineHeight: '1.75',
		color: titles,
		boxShadow: 'none',
		'::placeholder': {
			color: charmGray,
		},
		':disabled': {
			opacity: 0.6,
			cursor: 'not-allowed',
		},
		':focus': {
			boxShadow: 'none',
		},
	},
});
